import styled from 'styled-components'

export const Card = styled.div<{ disabled?: boolean }>`
  width: 100%;
  background: white;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid
    ${({ disabled }) => (disabled ? 'var(--Background-Neutral-faded, #DFE2EA)' : 'var(--border-neutral, #bbc1d3)')};
`

export const CardContent = styled.div<{ disabled: boolean }>`
  justify-content: center;
  display: flex;
`

export const CardFooter = styled.div`
  padding: 8px;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
`

export const SignatureContainer = styled.div<{ disabled: boolean; isEmpty: boolean }>`
  display: flex;

  border-bottom: ${({ disabled }) => (disabled ? 'none' : '1px dashed var(--border-neutral, #bbc1d3)')};
  cursor: ${({ disabled, isEmpty }) => (disabled ? 'not-allowed' : isEmpty ? 'crosshair' : 'default')};
  background: ${({ disabled }) => (disabled ? '#F4F5F7' : 'white')};
  flex: 1;

  align-content: center;
  justify-items: center;
`

export const Label = styled.div`
  color: #14171f;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`

export const FieldContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
`

export const Img = styled.img<{ width: number; height: number }>`
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
`
